import { DeclineCategoryRow } from './decline-reason-mapping.interface';

export interface DeclineMappingGridHostApi {
  readonly editingRowId: string | null;
  readonly editDraft: string;

  setEditDraft(v: string): void;
  startEdit(row: DeclineCategoryRow): void;
  commitEdit(explicit?: boolean): void;
  cancelEdit(): void;
  onEditKeydown(ev: KeyboardEvent): void;
  rowMappedCount(row: DeclineCategoryRow): number;
  refreshMappingCells(): void;
  isCellActive(rowId: string, portalId: string): boolean;
  clickCell(rowId: string, portalId: string): void;
  removeReason(row: DeclineCategoryRow, portalId: string, reason: string): void;
  deleteRow(rowId: string): void;
  requestDeleteConfirm(rowId: string): void;
}

export type DeclineMappingGridContext = { host: DeclineMappingGridHostApi };
